// extracted by mini-css-extract-plugin
export default {"toggle":"ViewModeToggle-module__toggle_Xu5P1","option":"ViewModeToggle-module__option_BHW6H","active":"ViewModeToggle-module__active_h7H79"};